import JwtService from "./core/services/jwt.service";
import router from "./router";
import {LOGOUT} from "@/core/services/store/auth.module";
import store from '@/core/services/store'
import {mapGetters} from "vuex";
import axios from "axios";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

let coreland = process.env.VUE_APP_CoreLandUrl;

let payamakland = process.env.VUE_APP_PayamakLandURL

const Mixin = {
    data() {
        return {
            surname: "Parisian",
        }
    },
    mounted() {
        console.log("Reza_Atom");
        $("input[name='table-search']").parent().removeClass('offset-md-6').addClass('ms-auto');
        this.getSpecialmenu()
    },
    methods: {
        datediff(first, second) {
            return Math.round((second - first) / (1000 * 60 * 60 * 24));
        },
        async generateRecaptchaToken(action) {
            await this.$recaptchaLoaded()
            return await this.$recaptcha(action);
        },
        coreLandApi(url) {
            return coreland + `/storage/${url}`;
        },
        toggleNavigation() {
            this.$store.dispatch('menu/toggle');
        },
        toggleMobileMenu() {
            this.$store.dispatch('menu/toggle');
            // this.$store.dispatch('menu/toggleMobile');
        },
        cloneObject(obj) {
            return JSON.parse(JSON.stringify(obj))
        },
        firstLetter(input) {
            if (!input) return "U";
            return input.charAt(0).toUpperCase().toString()
        },

        // summary(input){
        //     return input.substring(0,2)+'...'
        // },
        async getUserTokenWithId(id) {
            let response = await this.requestApiPost('admin/userLogin', {user_id: id});
            if (response.data.token) {
                return response.data.token;
            } else {
                throw (new DOMException("to token found"))
            }
        },
        authority() {
            this.requestApiGet('user')
                .then(({data}) => {
                    localStorage.setItem('userInfo', JSON.stringify(data));
                    store.dispatch('setUser', data)
                })
                .catch(({response}) => {
                    if (response.status === 401) {
                        this.logout();
                    }
                })
        },
        logout() {
            this.$toast.warning("لطفا وارد شوید");
            return this.$store
                .dispatch(LOGOUT)
                .then(() => this.$router.push({name: "login"}));
        },

        configurationFile() {
            return {
                headers: {'Content-Type': 'multipart/form-data'},
                onUploadProgress: function (progressEvent) {
                    this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    this.$forceUpdate();
                }.bind(this)
            };
        },
        getTime: function (input) {
            try {
                let time = input.split(" ")[1].split(":");
                return time[0] + ":" + time[1];
            } catch (e) {
                return input;
            }
        },
        jalalian: function (input) {
            try {
                let moment = require('moment-jalaali');
                let date = moment(input, 'YYYY/MM/DD');
                return date.format('jYYYY/jM/jD');
            } catch (e) {
                return input;
            }
        },
        datetime(input, type) {
            if (input == null || input.length === 0) return '-';

            if (type === 'datetime') {
                return `${this.jalalian(input)} ${this.getTime(input)}`;
            } else {
                return `${this.jalalian(input)}`
            }
        },
        dateString(input) {
            try {
                let moment = require('moment-jalaali')
                moment.locale("fa", null);
                moment.loadPersian({dialect: 'persian-modern'});
                return moment(input, 'YYYY-M-D HH:mm:ss').format('dddd LL');
            } catch (e) {
            }
        },

        openLink(url) {
            let a = document.createElement('a');
            // a.target = '_blank';
            a.href = url;
            a.click();
        },
        async checkTokenAsync(token) {
            try {
                let res = await axios.get(`${this.$sarveLand}/api/user`, {
                    headers: {
                        secret: process.env.VUE_APP_CoreSecret,
                        Authorization: `Bearer ${token}`
                    }
                })

                if (res.status === 200) {
                    localStorage.setItem('user_info', JSON.stringify(res.data));
                    this.$store.dispatch('setUser', res.data)
                    // store.dispatch('setUser',JSON.stringify(res.data));
                    // this.$router.push({name: 'dashboard'})
                }

            } catch (e) {
                ;
                if (e.response.status === 401) {
                    this.$store
                        .dispatch(LOGOUT)
                        .then(() => window.location.replace(`${this.$sarveLandFront}`));
                }

            }
        },
        async checkWalletAsync() {
            const vm = this;
            let walletInfo = '';

            try {
                let data = await axios.post(`${process.env.VUE_APP_CoreLandUrl + '/api'}/wallet`, {}, {
                    headers: this.header()
                });
                data = data.data;

                if (data.currency === 'Rial') {
                    walletInfo = this.changeMoney('rial');
                }
                if (data.currency === 'Toman') {
                    walletInfo = this.changeMoney('toman');
                }
                if (data.currency === 'Dollar') {
                    walletInfo = this.changeMoney('dollar');
                }
                if (data.currency === 'Euro') {
                    walletInfo = this.changeMoney('euro');
                }
                if (data.currency === 'Bitcoin') {
                    walletInfo = this.changeMoney('bitcoin');
                }
                if (data.currency === 'Ethereum') {
                    walletInfo = this.changeMoney('ethereum');
                }
                let user_wallet = {
                    'icon': walletInfo.icon,
                    'color': walletInfo.color,
                    'balance': data.balance
                }
                localStorage.setItem('user_wallet', JSON.stringify(user_wallet));
                this.$store.dispatch('wallet/setWallet', user_wallet);
            } catch (e) {

            }
        },


        getSpecialmenu() {
            $.ajax({
                url: `${url}/user/menus`,
                type: 'GET',
                fn: this.getSpecialmenu,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token
                },
                success: (data) => {

                    this.$store.dispatch('menu/items', data.data);


                },
            })
        },


        getService() {
            return service;
        },
        getUserStatus() {
            let status = this.getUser();
            return status.auth_validate;
        },
        getUser() {
            //TODO: delete id and private fields
            return JSON.parse(localStorage.getItem('userInfo'));
        },
        getWallet() {
            return JSON.parse(localStorage.getItem('user_wallet'));
        },

        checkWallet() {
            let walletInfo = '';
            axios.post(`${coreland + '/api'}/wallet`, {}, {
                headers: this.header()
            }).then(({data}) => {

                if (data.currency === 'Rial') {
                    walletInfo = this.changeMoney('rial');
                }
                if (data.currency === 'Toman') {
                    walletInfo = this.changeMoney('toman');
                }
                if (data.currency === 'Dollar') {
                    walletInfo = this.changeMoney('dollar');
                }
                if (data.currency === 'Euro') {
                    walletInfo = this.changeMoney('euro');
                }
                if (data.currency === 'Bitcoin') {
                    walletInfo = this.changeMoney('bitcoin');
                }
                if (data.currency === 'Ethereum') {
                    walletInfo = this.changeMoney('ethereum');
                }
                let user_wallet = {
                    'icon': walletInfo.icon,
                    'color': walletInfo.color,
                    'balance': data.balance
                }
                localStorage.setItem('user_wallet', JSON.stringify(user_wallet));
                this.$store.dispatch('wallet/setWallet', user_wallet);
            }).catch(({response}) => {
                if (response.status === 401) {
                    this.logout();
                }
            })
        },
        changeMoney(data) {
            return {
                'icon': money.data[data].icon,
                'color': money.data[data].color,
                'value': money.data[data].value,
            }
        },


        goto(route, query = {}) {
            router.push({path: "/" + route, query: query})
        },
        goReplace(route) {
            router.replace({path: "/" + route})
        },
        toggleNightMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            this.setCookie('theme', this.$vuetify.theme.dark, '60');
        },
        setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname, def = "") {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return def;
        },

        header() {
            return {
                Authorization: JwtService.getToken() ? `Bearer ${JwtService.getToken()}` : null,
                Accept: 'application/json',
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json',
            };
        },
        payamakHeader() {
            return {
                Authorization: JwtService.getToken() ? `Bearer ${JwtService.getToken()}` : null,
                Accept: 'application/json',
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json',
            };
        },


        requestApiGet(uri, queries = {}) {
            return axios.get(`${coreland + '/api'}/${uri}`, {
                headers: this.header(),
                params: queries
            });
        },
        requestApiGetPayamak(uri, queries = {}) {
            return axios.get(`${payamakland + '/api'}/${uri}`, {
                headers: this.payamakHeader(),
                params: queries
            });
        },
        requestApiPostPayamak(uri, data = {}) {
            return axios.post(`${payamakland + '/api'}/${uri}`, data, {
                headers: this.payamakHeader(),
            });
        },

        requestApiPost(uri, data = {}) {
            return axios.post(`${coreland + '/api'}/${uri}`, data, {
                headers: this.header(),
            });
        },
        requestApiPostLogin(uri, data = {}) {
            return axios.post(`${coreland + '/api'}/${uri}`, data);
        },
        requestApiPut(uri, data = {}, queries = {}) {
            return axios.put(`${coreland + '/api'}/${uri}`, data, {
                headers: this.header(),
                params: queries
            });
        },
        requestApiDelete(uri, queries = {}) {
            return axios.delete(`${coreland + '/api'}/${uri}`, {
                headers: this.header(),
                params: queries
            });
        },
        persian(input) {
            if (input === undefined || input == null) return "";
            let str1 = input.toString().trim();
            if (str1 === '') return '';
            str1 = str1.replace(/0/img, '۰');
            str1 = str1.replace(/1/img, '۱');
            str1 = str1.replace(/2/img, '۲');
            str1 = str1.replace(/3/img, '۳');
            str1 = str1.replace(/4/img, '۴');
            str1 = str1.replace(/5/img, '۵');
            str1 = str1.replace(/6/img, '۶');
            str1 = str1.replace(/7/img, '۷');
            str1 = str1.replace(/8/img, '۸');
            str1 = str1.replace(/9/img, '۹');
            return str1;
        },

        setBreadcrumb(title) {
            this.$store.dispatch(SET_BREADCRUMB, [{title}]);
        },
        english(input) {
            if (input === undefined || input == null) return "";
            let str1 = input.toString().trim();
            if (str1 === '') return '';
            str1 = str1.replace(/۰/img, '0');
            str1 = str1.replace(/۱/img, '1');
            str1 = str1.replace(/۲/img, '2');
            str1 = str1.replace(/۳/img, '3');
            str1 = str1.replace(/۴/img, '4');
            str1 = str1.replace(/۵/img, '5');
            str1 = str1.replace(/۶/img, '6');
            str1 = str1.replace(/۷/img, '7');
            str1 = str1.replace(/۸/img, '8');
            str1 = str1.replace(/۹/img, '9');
            return str1;
        },
        objectLength(obj) {
            try {
                return Object.keys(obj).length;
            } catch (e) {

            }
        },
        validatePhone(input) {
            let message = '';

            if (!/^[\+]?[(]?[0][-\s\.]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im.test(input.phone)) {
                message = 'فیلد تلفن همراه را صحیح وارد نمایید!';
            } else {
                return true;
            }

            return false;
        },

        coreLandUrl(url) {
            return coreland + `/${url}`;
        },


        price: function (input) {
            try {
                return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            } catch (e) {
                return input;
            }
        },

        unprice: function (input) {
            try {
                return input.replace(/,/g, '')
            } catch (e) {
                return input;
            }
        },
        permissionStatus(permissionName) {
            this.requestApiPost('abilitiesStatus', {'name': permissionName}).then(response => {
                if (response.data === 'show') {
                    // window.alert('شما به این بخش دسترسی ندارید!');
                    return false;
                }
                // window.alert('done')
                return true;
                // return response.data
            });
        }
    },
    computed: {
        ...mapGetters(['user']),
        wallet() {
            return this.$store.getters['wallet/wallet']
        }
    },

}

export {Mixin}

export default {
    install(Vue, options) {
        Vue.mixin(Mixin)
    }
}





